// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5285f223","455":"0eebd8ae","557":"8f442b24","701":"962eef42"}[chunkId] + ".chunk.js";
};